/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "../FormField";

// EditProduct page components

function Socials({formData}) {
  const { formField, values, errors, touched } = formData;
  const { website, twitter, facebook, instagram } = formField;
  const { website: websiteV, twitter:twitterV, facebook: facebookV, instagram: instagramV } = values;

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5" fontWeight="bold">
          Socials
        </MDTypography>
        <MDBox mt={1}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormField type={website.type}
                         label={website.label}
                         name={website.name}
                         value={websiteV}
                         placeholder={website.placeholder}
                         error={errors.website && touched.website}
                         success={websiteV.length > 0 && !errors.website}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField type={twitter.type}
                         label={twitter.label}
                         name={twitter.name}
                         value={twitterV}
                         placeholder={twitter.placeholder}
                         error={errors.twitter && touched.twitter}
                         success={twitterV.length > 0 && !errors.twitter}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField type={facebook.type}
                         label={facebook.label}
                         name={facebook.name}
                         value={facebookV}
                         placeholder={facebook.placeholder}
                         error={errors.facebook && touched.facebook}
                         success={facebookV.length > 0 && !errors.facebook}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField type={instagram.type}
                         label={instagram.label}
                         name={instagram.name}
                         value={instagramV}
                         placeholder={instagram.placeholder}
                         error={errors.instagram && touched.instagram}
                         success={instagramV.length > 0 && !errors.instagram}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Socials;
